export const SAYFA_GRUPLARI = ['Kurumsal', 'Yönetim', 'Programlar', 'Öğrenci', 'Araştırma'];

export const SAYFA_CONFIGS = {
  /* ── KURUMSAL ── */
  'misyon-vizyon': {
    label: 'Misyon & Vizyon',
    group: 'Kurumsal',
    fields: [
      { key: 'hero_subtitle',              label: 'Hero Alt Başlık',               type: 'textarea', i18nKey: 'mission_vision.hero.subtitle' },
      { key: 'misyon_baslik',              label: 'Misyon Başlığı',                type: 'text',     i18nKey: 'mission_vision.mission.title' },
      { key: 'misyon_metni',               label: 'Misyon Metni',                  type: 'textarea', i18nKey: 'mission_vision.mission.description' },
      { key: 'vizyon_baslik',              label: 'Vizyon Başlığı',                type: 'text',     i18nKey: 'mission_vision.vision.title' },
      { key: 'vizyon_metni',               label: 'Vizyon Metni',                  type: 'textarea', i18nKey: 'mission_vision.vision.description' },
      { key: 'deger1_baslik',              label: 'Değer 1 – Başlık',              type: 'text',     i18nKey: 'mission_vision.values.scientific_excellence.title' },
      { key: 'deger1_aciklama',            label: 'Değer 1 – Açıklama',            type: 'textarea', i18nKey: 'mission_vision.values.scientific_excellence.description' },
      { key: 'deger2_baslik',              label: 'Değer 2 – Başlık',              type: 'text',     i18nKey: 'mission_vision.values.innovation.title' },
      { key: 'deger2_aciklama',            label: 'Değer 2 – Açıklama',            type: 'textarea', i18nKey: 'mission_vision.values.innovation.description' },
      { key: 'deger3_baslik',              label: 'Değer 3 – Başlık',              type: 'text',     i18nKey: 'mission_vision.values.social_benefit.title' },
      { key: 'deger3_aciklama',            label: 'Değer 3 – Açıklama',            type: 'textarea', i18nKey: 'mission_vision.values.social_benefit.description' },
      { key: 'banner_baslik',              label: 'Alt Banner Başlığı',            type: 'text',     i18nKey: 'mission_vision.bottom_banner.title' },
      { key: 'banner_altyazi',             label: 'Alt Banner Alt Yazısı',         type: 'textarea', i18nKey: 'mission_vision.bottom_banner.subtitle' },
    ],
  },
  'stratejik-plan': {
    label: 'Stratejik Plan',
    group: 'Kurumsal',
    fields: [
      { key: 'p1', label: '1. Paragraf', type: 'textarea', i18nKey: 'pages.strategic_plan.p1' },
      { key: 'p2', label: '2. Paragraf', type: 'textarea', i18nKey: 'pages.strategic_plan.p2' },
      { key: 'p3', label: '3. Paragraf', type: 'textarea', i18nKey: 'pages.strategic_plan.p3' },
    ],
  },
  'fedek': {
    label: 'FEDEK',
    group: 'Kurumsal',
    fields: [
      { key: 'p1', label: 'FEDEK Nedir? (1. paragraf)', type: 'textarea', i18nKey: 'fedek.p1' },
      { key: 'p2', label: 'FEDEK Nedir? (2. paragraf)', type: 'textarea', i18nKey: 'fedek.p2' },
      { key: 'p3', label: 'FEDEK Akreditasyonu Açıklama', type: 'textarea', i18nKey: 'fedek.p3' },
    ],
  },

  /* ── YÖNETİM ── */
  'dekan-mesaji': {
    label: 'Dekan Mesajı',
    group: 'Yönetim',
    fields: [
      { key: 'p1', label: 'Açılış / Hitap', type: 'text',     i18nKey: 'pages.dean.message.p1' },
      { key: 'p2', label: 'Ana Mesaj',      type: 'textarea', i18nKey: 'pages.dean.message.p2' },
      { key: 'p3', label: 'Kapanış',        type: 'textarea', i18nKey: 'pages.dean.message.p3' },
    ],
  },

  /* ── PROGRAMLAR ── */
  'lisans': {
    label: 'Lisans Programları',
    group: 'Programlar',
    fields: [
      { key: 'biyoloji',  label: 'Biyoloji Açıklama',  type: 'textarea', i18nKey: 'undergraduate.program_descriptions.biology' },
      { key: 'kimya',     label: 'Kimya Açıklama',     type: 'textarea', i18nKey: 'undergraduate.program_descriptions.chemistry' },
      { key: 'matematik', label: 'Matematik Açıklama', type: 'textarea', i18nKey: 'undergraduate.program_descriptions.mathematics' },
      { key: 'istatistik',label: 'İstatistik Açıklama',type: 'textarea', i18nKey: 'undergraduate.program_descriptions.statistics' },
      { key: 'aktuerya',  label: 'Aktüerya Açıklama',  type: 'textarea', i18nKey: 'undergraduate.program_descriptions.actuarial' },
    ],
  },
  'yuksek-lisans': {
    label: 'Yüksek Lisans',
    group: 'Programlar',
    fields: [
      { key: 'baslik',  label: 'Sayfa Başlığı', type: 'text',     i18nKey: 'pages.masters.title' },
      { key: 'altyazi', label: 'Alt Yazı',      type: 'textarea', i18nKey: 'pages.masters.subtitle' },
      { key: 'aciklama',label: 'Açıklama',      type: 'richtext', i18nKey: 'pages.masters.description' },
    ],
  },
  'doktora': {
    label: 'Doktora',
    group: 'Programlar',
    fields: [
      { key: 'baslik',  label: 'Sayfa Başlığı', type: 'text',     i18nKey: 'pages.doctorate.title' },
      { key: 'altyazi', label: 'Alt Yazı',      type: 'textarea', i18nKey: 'pages.doctorate.subtitle' },
      { key: 'aciklama',label: 'Açıklama',      type: 'richtext', i18nKey: 'pages.doctorate.description' },
    ],
  },
  'erasmus': {
    label: 'Erasmus',
    group: 'Programlar',
    fields: [
      { key: 'baslik',      label: 'Sayfa Başlığı',  type: 'text',     i18nKey: 'erasmus.title' },
      { key: 'altyazi',     label: 'Alt Yazı',       type: 'textarea', i18nKey: 'erasmus.subtitle' },
      { key: 'aciklama',    label: 'Açıklama',       type: 'richtext', i18nKey: 'erasmus.description' },
    ],
  },
  'yandal': {
    label: 'Yan Dal',
    group: 'Programlar',
    fields: [
      { key: 'baslik',  label: 'Sayfa Başlığı', type: 'text',     i18nKey: 'pages.minor.title' },
      { key: 'aciklama',label: 'Açıklama',      type: 'richtext', i18nKey: 'pages.minor.description' },
    ],
  },
  'cift-anadal': {
    label: 'Çift Ana Dal',
    group: 'Programlar',
    fields: [
      { key: 'baslik',  label: 'Sayfa Başlığı', type: 'text',     i18nKey: 'pages.doubleMajor.title' },
      { key: 'aciklama',label: 'Açıklama',      type: 'richtext', i18nKey: 'pages.doubleMajor.description' },
    ],
  },

  /* ── ÖĞRENCİ ── */
  'staj': {
    label: 'Staj',
    group: 'Öğrenci',
    fields: [
      { key: 'altyazi',           label: 'Alt Başlık',               type: 'textarea', i18nKey: 'internship_page.subtitle' },
      { key: 'genel_aciklama',    label: 'Genel Açıklama',           type: 'textarea', i18nKey: 'internship_page.general_info.description' },
      { key: 'akt_aciklama',      label: 'Aktüerya Bölümü Açıklama', type: 'textarea', i18nKey: 'internship_page.departments_section.actuarial.description' },
      { key: 'bio_aciklama',      label: 'Biyoloji Bölümü Açıklama', type: 'textarea', i18nKey: 'internship_page.departments_section.biology.description' },
      { key: 'ist_aciklama',      label: 'İstatistik Bölümü Açıklama',type: 'textarea',i18nKey: 'internship_page.departments_section.statistics.description' },
      { key: 'kim_aciklama',      label: 'Kimya Bölümü Açıklama',    type: 'textarea', i18nKey: 'internship_page.departments_section.chemistry.description' },
      { key: 'mat_aciklama',      label: 'Matematik Bölümü Açıklama',type: 'textarea', i18nKey: 'internship_page.departments_section.mathematics.description' },
    ],
  },
  'engelsiz-yasam': {
    label: 'Engelsiz Yaşam',
    group: 'Öğrenci',
    fields: [
      { key: 'baslik',      label: 'Sayfa Başlığı',   type: 'text',     i18nKey: 'accessible_life.title' },
      { key: 'altyazi',     label: 'Alt Başlık',      type: 'textarea', i18nKey: 'accessible_life.subtitle' },
      { key: 'vizyon_baslik',label: 'Vizyon Başlığı', type: 'text',     i18nKey: 'accessible_life.vision.title' },
      { key: 'vizyon_metni', label: 'Vizyon Metni',   type: 'textarea', i18nKey: 'accessible_life.vision.description' },
      { key: 'sütun1_baslik',label: 'Sütun 1 Başlık', type: 'text',     i18nKey: 'accessible_life.pillars.0.title' },
      { key: 'sütun1_metin', label: 'Sütun 1 Metin',  type: 'textarea', i18nKey: 'accessible_life.pillars.0.description' },
      { key: 'sütun2_baslik',label: 'Sütun 2 Başlık', type: 'text',     i18nKey: 'accessible_life.pillars.1.title' },
      { key: 'sütun2_metin', label: 'Sütun 2 Metin',  type: 'textarea', i18nKey: 'accessible_life.pillars.1.description' },
      { key: 'sütun3_baslik',label: 'Sütun 3 Başlık', type: 'text',     i18nKey: 'accessible_life.pillars.2.title' },
      { key: 'sütun3_metin', label: 'Sütun 3 Metin',  type: 'textarea', i18nKey: 'accessible_life.pillars.2.description' },
      { key: 'sütun4_baslik',label: 'Sütun 4 Başlık', type: 'text',     i18nKey: 'accessible_life.pillars.3.title' },
      { key: 'sütun4_metin', label: 'Sütun 4 Metin',  type: 'textarea', i18nKey: 'accessible_life.pillars.3.description' },
    ],
  },
  'sosyal-sorumluluk': {
    label: 'Sosyal Sorumluluk',
    group: 'Öğrenci',
    fields: [
      { key: 'baslik',  label: 'Sayfa Başlığı', type: 'text',     i18nKey: 'social_responsibility.title' },
      { key: 'altyazi', label: 'Alt Başlık',    type: 'textarea', i18nKey: 'social_responsibility.subtitle' },
      { key: 'intro',   label: 'Giriş Metni',   type: 'richtext', i18nKey: 'social_responsibility.intro' },
    ],
  },

  /* ── ARAŞTIRMA ── */
  'laboratuvarlar': {
    label: 'Araştırma Laboratuvarları',
    group: 'Araştırma',
    fields: [
      { key: 'hero_desc', label: 'Hero Açıklama',      type: 'textarea', i18nKey: 'pages.researchLabs.heroDescription' },
      { key: 'etki_pub',  label: 'Yayınlar Açıklama',  type: 'textarea', i18nKey: 'pages.researchLabs.publicationsDesc' },
      { key: 'etki_odul', label: 'Ödüller Açıklama',   type: 'textarea', i18nKey: 'pages.researchLabs.awardsDesc' },
      { key: 'etki_isb',  label: 'İş Birlikleri Açıklama', type: 'textarea', i18nKey: 'pages.researchLabs.collaborationsDesc' },
      { key: 'etki_inov', label: 'İnovasyon Açıklama', type: 'textarea', i18nKey: 'pages.researchLabs.innovationDesc' },
    ],
  },
};
